export const handleImageSizeLimit = (e, items, editor) => {
  for (var i = 0; i < items.length; i++) {
    if (items[i]?.type.indexOf("image") !== -1) {
      var imageSize = items[i]?.getAsFile().size;

      if (imageSize > 200 * 1024) {
        e.preventDefault();

        editor.notificationManager.open({
          text: "Image size exceeds 200 KB limit",
          type: "error",
        });

        return false;
      }
    }
  }

  return true;
};
